var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-slider mb-md-4"},[_c('flickity',{ref:"flickity",attrs:{"options":_vm.flickityOptions}},_vm._l((_vm.images),function(image,index){return _c('div',{key:index,staticClass:"carousel-cell"},[_c('img',{attrs:{"src":image,"width":"100%","alt":""},on:{"click":function($event){return _vm.openPreview(index)}}})])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }